import { render, staticRenderFns } from "./BatchDetailsContainer.vue?vue&type=template&id=0ec19086"
import script from "./BatchDetailsContainer.vue?vue&type=script&lang=js"
export * from "./BatchDetailsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports